import { QueueModel } from 'api/dto/Queue.dto';
import { Resource } from 'model/Resource';
import { TakeLatestNew } from 'shared/utils/type';

export const STORE_NAME = 'queue';

export namespace QueueState {
  export type Domain = {
    projectQueues: TakeLatestNew<Resource<QueueModel[] | null>>;
  };

  export const INITIAL_DOMAIN: QueueState.Domain = {
    projectQueues: {
      data: Resource.createPendingResource<QueueModel[]>(),
      requestId: '',
    },
  };
}
